import { z } from "zod";

const CheckSchema = z.strictObject({
  ok: z.boolean(),
  /** Short machine detail, never a secret or a provider body. */
  detail: z.string().optional(),
  latencyMs: z.number().optional(),
});
export type HealthCheck = z.infer<typeof CheckSchema>;

export const HealthResponseSchema = z.strictObject({
  ok: z.boolean(),
  checks: z.strictObject({
    postgres: CheckSchema,
    bucket: CheckSchema,
    ffmpeg: CheckSchema,
    worker: CheckSchema,
  }),
  version: z.string().optional(),
});
export type HealthResponse = z.infer<typeof HealthResponseSchema>;
